import React from 'react';
import { motion } from 'framer-motion';
import { Palette, Scissors, GraduationCap, ArrowRight } from 'lucide-react';
const courses = [{
  title: 'Técnicas de Colorimetría',
  description: 'Domina la decoloración perfecta, platinados extremos y colores fantasía vibrantes sin dañar la fibra capilar.',
  icon: Palette,
  color: 'from-neon-violet to-fuchsia-500',
  image: 'https://cdn.magicpatterns.com/uploads/ddKeEZZigdhS4QDqG5pGJD/El_amor_al_arte_no_se_explica…_se_siente.Cada_linea,_cada_seccion,_cada_detalle_en_este_corte_ha.jpg'
}, {
  title: 'Corte y Estilo 2.0',
  description: 'Estructuras avanzadas, texturas modernas y fades milimétricos. Eleva tu técnica de corte al estándar internacional.',
  icon: Scissors,
  color: 'from-fuchsia-500 to-cyan-400',
  image: 'https://cdn.magicpatterns.com/uploads/ddKeEZZigdhS4QDqG5pGJD/El_amor_al_arte_no_se_explica…_se_siente.Cada_linea,_cada_seccion,_cada_detalle_en_este_corte_ha.jpg'
}, {
  title: 'Masterclass Presencial',
  description: 'Inmersión total en El Pinar. Práctica en modelos reales, marketing para barberos y creación de marca personal.',
  icon: GraduationCap,
  color: 'from-cyan-400 to-neon-green',
  image: 'https://cdn.magicpatterns.com/uploads/ddKeEZZigdhS4QDqG5pGJD/El_amor_al_arte_no_se_explica…_se_siente.Cada_linea,_cada_seccion,_cada_detalle_en_este_corte_ha.jpg'
}];
export function Academy() {
  return <section id="academia" className="py-32 relative" data-id="element-42">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-43">
        <div className="text-center mb-20" data-id="element-44">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display text-5xl md:text-7xl mb-4" data-id="element-45">
            Formación{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-violet to-neon-green" data-id="element-46">
              2.0
            </span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-47">
            Perfeccionamiento exclusivo para barberos que buscan destacar.
            Aprende los secretos detrás de los looks más virales.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-48">
          {courses.map((course, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="group relative bg-white/[0.03] border border-white/10 backdrop-blur-lg rounded-3xl p-8 hover:-translate-y-2 transition-all duration-300 hover:bg-white/[0.05] hover:border-white/20 overflow-hidden" data-id="element-49">
              {/* Background Image with Overlay */}
              <div className="absolute inset-0 z-0" data-id="element-50">
                <img src={course.image} alt={course.title} className="w-full h-full object-cover opacity-20 group-hover:opacity-30 transition-opacity duration-500" data-id="element-51" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/80 to-transparent" data-id="element-52" />
              </div>

              {/* Content Wrapper to keep it above the background */}
              <div className="relative z-10" data-id="element-53">
                {/* Hover Glow */}
                <div className={`absolute -top-8 -left-8 w-[calc(100%+4rem)] h-1 bg-gradient-to-r ${course.color} opacity-0 group-hover:opacity-100 transition-opacity duration-300`} data-id="element-54" />

                <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${course.color} p-[1px] mb-6`} data-id="element-55">
                  <div className="w-full h-full bg-[#0a0a0a] rounded-2xl flex items-center justify-center group-hover:bg-transparent transition-colors duration-300" data-id="element-56">
                    <course.icon size={24} className="text-white" data-id="element-57" />
                  </div>
                </div>

                <h3 className="text-2xl font-bold mb-3 text-white" data-id="element-58">
                  {course.title}
                </h3>
                <p className="text-gray-300 mb-8 leading-relaxed" data-id="element-59">
                  {course.description}
                </p>

                <a href="#contacto" className="inline-flex items-center gap-2 text-sm font-semibold text-white group-hover:text-neon-green transition-colors" data-id="element-60">
                  Más información
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-61" />
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}